import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import Stack, { StackProps } from "@rui/Stack";

export const TimeSeriesChartContainer = styled((props: StackProps) => (
  <Stack direction="row" variant="center" spacing={0.5} {...props} />
))(() => ({
  height: "24px",
  flexGrow: 1,
  minWidth: 0,
}));

export const TimeSeriesChartTitle = styled((props: TypographyProps) => (
  <Typography variant="labelMed" {...props} />
))(({ theme }) => ({
  whiteSpace: "nowrap",
  color: theme.palette.shades.neutral[700],
}));
